import { RaffleTicketsFilter, TicketFilterMap } from '../types/common.types';

export const TICKET_FILTERS: TicketFilterMap = {
  ACTIVE: {
    filterText: 'Devam Edenler',
    noFilteredItemText: 'Henüz bilet satın almadınız.',
    noFilteredItemDescriptionText:
      'Mevcut çekilişlerden satın alarak biletinizi buradan görüntüleyebilirsiniz.',
  },
  COMPLETED: {
    filterText: 'Sonuçlanan Biletlerim',
    noFilteredItemText: 'Henüz tamamlanmış çekilişiniz yok.',
    noFilteredItemDescriptionText:
      'Çekilişi sonuçlanan  biletlerinizi buradan görüntüleyebilirsiniz.',
  },
  WINNINGS: {
    filterText: 'Kazandıklarım',
    noFilteredItemText: 'Henüz kazanan biletiniz yok.',
    noFilteredItemDescriptionText:
      'Satın aldığınız biletlerden bir ödül kazandığınızda burdan görüntüleyebilirsiniz.',
  },
};

export const DEFAULT_USER_TICKETS_FILTER: RaffleTicketsFilter = 'ACTIVE';
